import image1 from '../../../Assets/Cards/marketing.webp';
import image2 from '../../../Assets/Cards/non.png';
import image3 from '../../../Assets/Cards/beginner.png';
import image4 from '../../../Assets/Cards/tools.png';

 export const booksData = [
     {
         image:image1,
         title:"Marketing Strategies We Used to Boostrap Hostcharts to over 4 Million users",
         desc:"Learn, step-by-step, all the marketing strategies we’ve used to grow Hostcharts to 4 million users. Our team has spent 450 hours documenting every single tactic we’ve implemented to reach."
     },
     {
         image:image2,
         title:"A Non-Designer’s Guide to Creating Memorable Visual Presentations",
         desc:"If you want to raise the bar on your presentations, this book is for you. Chock full of visual examples, cheat sheets and case studies, this step-by-step visual guide will show you practical design tricks to take."
     },
     {
         image:image3,
         title:"A Beginner's Guide to Creating Shareable Infographics",
         desc:"Learn how to make informative and engaging infographics that get noticed and help you properly translate your ideas into engaging visuals so that you can extend their reach and lifespan on the web. We've created…"
     },
     {
         image:image4,
         title:"24 Essential Tools and Resources for Startups and Entrepreneurs",
         desc:"Looking to start your own business and don’t know where to begin? Our list of essential apps and tools gives you a good starting point, with dozens of free resources to help you manage and grow your business."
     },
     {
        image:image1,
        title:"Marketing Strategies We Used to Boostrap Hostcharts to over 4 Million users",
        desc:"Learn, step-by-step, all the marketing strategies we’ve used to grow Hostcharts to 4 million users. Our team has spent 450 hours documenting every single tactic we’ve implemented to reach."
    },
    {
        image:image2,
        title:"A Non-Designer’s Guide to Creating Memorable Visual Presentations",
        desc:"If you want to raise the bar on your presentations, this book is for you. Chock full of visual examples, cheat sheets and case studies, this step-by-step visual guide will show you practical design tricks to take."
    },
    {
        image:image3,
        title:"A Beginner's Guide to Creating Shareable Infographics",
        desc:"Learn how to make informative and engaging infographics that get noticed and help you properly translate your ideas into engaging visuals so that you can extend their reach and lifespan on the web. We've created…"
    },
    {
        image:image4,
        title:"24 Essential Tools and Resources for Startups and Entrepreneurs",
        desc:"Looking to start your own business and don’t know where to begin? Our list of essential apps and tools gives you a good starting point, with dozens of free resources to help you manage and grow your business."
    },
    {
        image:image1,
        title:"Marketing Strategies We Used to Boostrap Hostcharts to over 4 Million users",
        desc:"Learn, step-by-step, all the marketing strategies we’ve used to grow Hostcharts to 4 million users. Our team has spent 450 hours documenting every single tactic we’ve implemented to reach."
    },
    {
        image:image2,
        title:"A Non-Designer’s Guide to Creating Memorable Visual Presentations",
        desc:"If you want to raise the bar on your presentations, this book is for you. Chock full of visual examples, cheat sheets and case studies, this step-by-step visual guide will show you practical design tricks to take."
    },
    {
        image:image3,
        title:"A Beginner's Guide to Creating Shareable Infographics",
        desc:"Learn how to make informative and engaging infographics that get noticed and help you properly translate your ideas into engaging visuals so that you can extend their reach and lifespan on the web. We've created…"
    },
    {
        image:image4,
        title:"24 Essential Tools and Resources for Startups and Entrepreneurs",
        desc:"Looking to start your own business and don’t know where to begin? Our list of essential apps and tools gives you a good starting point, with dozens of free resources to help you manage and grow your business."
    },
    {
       image:image1,
       title:"Marketing Strategies We Used to Boostrap Hostcharts to over 4 Million users",
       desc:"Learn, step-by-step, all the marketing strategies we’ve used to grow Hostcharts to 4 million users. Our team has spent 450 hours documenting every single tactic we’ve implemented to reach."
   },
   {
       image:image2,
       title:"A Non-Designer’s Guide to Creating Memorable Visual Presentations",
       desc:"If you want to raise the bar on your presentations, this book is for you. Chock full of visual examples, cheat sheets and case studies, this step-by-step visual guide will show you practical design tricks to take."
   },
   {
       image:image3,
       title:"A Beginner's Guide to Creating Shareable Infographics",
       desc:"Learn how to make informative and engaging infographics that get noticed and help you properly translate your ideas into engaging visuals so that you can extend their reach and lifespan on the web. We've created…"
   },
   {
       image:image4,
       title:"24 Essential Tools and Resources for Startups and Entrepreneurs",
       desc:"Looking to start your own business and don’t know where to begin? Our list of essential apps and tools gives you a good starting point, with dozens of free resources to help you manage and grow your business."
   },
   {
    image:image1,
    title:"Marketing Strategies We Used to Boostrap Hostcharts to over 4 Million users",
    desc:"Learn, step-by-step, all the marketing strategies we’ve used to grow Hostcharts to 4 million users. Our team has spent 450 hours documenting every single tactic we’ve implemented to reach."
},
{
    image:image2,
    title:"A Non-Designer’s Guide to Creating Memorable Visual Presentations",
    desc:"If you want to raise the bar on your presentations, this book is for you. Chock full of visual examples, cheat sheets and case studies, this step-by-step visual guide will show you practical design tricks to take."
},
{
    image:image3,
    title:"A Beginner's Guide to Creating Shareable Infographics",
    desc:"Learn how to make informative and engaging infographics that get noticed and help you properly translate your ideas into engaging visuals so that you can extend their reach and lifespan on the web. We've created…"
},
{
    image:image4,
    title:"24 Essential Tools and Resources for Startups and Entrepreneurs",
    desc:"Looking to start your own business and don’t know where to begin? Our list of essential apps and tools gives you a good starting point, with dozens of free resources to help you manage and grow your business."
},
{
   image:image1,
   title:"Marketing Strategies We Used to Boostrap Hostcharts to over 4 Million users",
   desc:"Learn, step-by-step, all the marketing strategies we’ve used to grow Hostcharts to 4 million users. Our team has spent 450 hours documenting every single tactic we’ve implemented to reach."
},
{
   image:image2,
   title:"A Non-Designer’s Guide to Creating Memorable Visual Presentations",
   desc:"If you want to raise the bar on your presentations, this book is for you. Chock full of visual examples, cheat sheets and case studies, this step-by-step visual guide will show you practical design tricks to take."
},
{
   image:image3,
   title:"A Beginner's Guide to Creating Shareable Infographics",
   desc:"Learn how to make informative and engaging infographics that get noticed and help you properly translate your ideas into engaging visuals so that you can extend their reach and lifespan on the web. We've created…"
},
{
   image:image4,
   title:"24 Essential Tools and Resources for Startups and Entrepreneurs",
   desc:"Looking to start your own business and don’t know where to begin? Our list of essential apps and tools gives you a good starting point, with dozens of free resources to help you manage and grow your business."
}
 ]


